import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {AccountAvatar, CardData, CardTitle} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";
import "./accountCard.css";

const AccountCard = (props) => {
    const {appRenderer, filters, account, children} = props;
    const branding = account.branding;

    return <Card className="account-card" raised={true}>
        <CardContent>
            <CardTitle>
                <AccountAvatar account={account} mode="no-title"
                               size={branding.logoContainsName ? "plus" : "medium"}
                               clickable={true}
                />
                {!branding.logoContainsName ? account.name : null}
            </CardTitle>
            <CardData
                filters={filters}
                data={account}
                keyToMetadata={{
                    appId: {
                        title: "App",
                        formatter: appRenderer.render,
                    },
                    status: {
                        title: "Status",
                        className: "status " + account.status,
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default AccountCard;
